import { FaArrowLeft } from "react-icons/fa6";
import { BsChatSquareText } from "react-icons/bs";
import { X, SendHorizontal, MoreHorizontal } from "lucide-react";
import { useChat } from "../../hook/useChat";
import { useState, useRef, useEffect, useCallback } from "react";
import "./style.css";

const Chatbot = ({ onBack , toggleChat}) => {
  const {
    isViewingHistory,
    messages,
    chats,
    messageLoading,
    inputMessage,
    messagesEndRef,
    setInputMessage,
    handleSendMessage,
    fetchChatHistory,
    setIsViewingHistory,
    selectedOptions,
    handleSelectOption,
    handleBacktoMainMenu
  } = useChat();

  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleViewHistory = useCallback(() => {
    fetchChatHistory();
    setIsViewingHistory(true);
    setDropdownOpen(false);
  }, [fetchChatHistory, setIsViewingHistory]);

  const handleBackToCurrentChat = useCallback(() => {
    setIsViewingHistory(false);
  }, [setIsViewingHistory]);

  const handleToggleDropdown = useCallback(() => {
    setDropdownOpen((prev) => !prev);
  }, []);


  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="chat-container">
      <div className="chat-header">
        <div className="chat-header-left">
          {isViewingHistory ? (
            <button onClick={handleBackToCurrentChat} className="back-btn">
              <FaArrowLeft />
            </button>
          ) : (
            <>
              <button onClick={onBack} className="back-btn">
                <FaArrowLeft />
              </button>
              <div className="dropdown">
                <button
                  onClick={handleToggleDropdown}
                  className="dropdown-btn"
                  aria-haspopup="true"
                  aria-expanded={isDropdownOpen}
                >
                  <MoreHorizontal className="icon" />
                </button>
                {isDropdownOpen && (
                  <div ref={dropdownRef} className="dropdown-menu">
                    <ul>
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={handleViewHistory}
                        >
                          <div className="dropdown-text">
                            Chat History <BsChatSquareText className="history_icon" />
                          </div>
                        </button>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
        <img src="/chatbot.png" className="chat-logo" alt="Chatbot Logo" />
        <button className="close-btn" onClick={() => { console.log('X clicked'); toggleChat()}}>
          <X className="icon" />
        </button>
      </div>
      <div className="chat-body">
        {isViewingHistory ? (
          <div className="chat-history">
            {chats.length ? (
              chats
            .filter((chat) => {
              const chatTime = new Date(chat.created_at);
              const oneHourAgo = new Date();
              oneHourAgo.setHours(oneHourAgo.getHours() - 1);
              return chatTime >= oneHourAgo; // Only show chats from the last 1 hour
            }).map((chat, index) => (
                <div key={index} className="message-wrapper">
                  {chat.bot_response && (
                    <div className="bot-message">
                      {chat.bot_response}
                      <span className="timestamp">
                        {new Date(chat.created_at).toLocaleTimeString()}
                      </span>
                    </div>
                  )}
                  {chat.user_message && (
                    <div className="user-message">
                      {chat.user_message}
                      <span className="timestamp">
                        {new Date(chat.created_at).toLocaleTimeString()}
                      </span>
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div className="no-messages">No chat history available.</div>
            )}
            <div ref={messagesEndRef} />
          </div>
        ) : (
          <>
            {messages?.length > 0 && (
              <div className="message-wrapper">
                {messages.map((message, index) => (
                  <div key={index} className={`message ${message.isBot ? "bot" : "user"}`}>
                    <div className="message-box">
                      <p className="message-text">{message.content}</p>
                      <span className="timestamp">
                        {new Date(message.timestamp).toLocaleTimeString()}
                      </span>
                    </div>
                  </div>
                ))}
                <div></div>
              </div>
            )}
            {messageLoading && (
              <div className="snake-loader">
                <div className="snake-dot"></div>
                <div className="snake-dot"></div>
                <div className="snake-dot"></div>
              </div>
            )}
            {selectedOptions.length > 0 && (
              <div className="options">
                {selectedOptions.map((option, index) => (
                  <button
                    key={index}
                    onClick={() => handleSelectOption(option.label)}
                    className="option-btn"
                  >
                    {option.value}
                  </button>
                ))}
              </div>
            )}
            {!messageLoading && selectedOptions.length === 0 && (
              <button onClick={() => handleBacktoMainMenu()} className="menu-btn">
                ⬅️ Back to Main Menu
              </button>
            )}
            <div ref={messagesEndRef} />
          </>
        )}
      </div>

      <div className="chat-footer">
        <input
          className="chat-input"
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
          disabled={isViewingHistory}
          onKeyDown={handleKeyPress}
          placeholder="Type a message..."
        />
        <button
          className={`send-btn ${messageLoading ? "disabled" : ""}`}
          onClick={handleSendMessage}
          disabled={messageLoading || isViewingHistory}
        >
          <SendHorizontal className="send-icon" />
        </button>
      </div>
    </div>
  );
};

export default Chatbot;